"use strict";

class SuperUnitTypesIndexController {

    constructor(SSUtilService, SSUserService) {
        const self = this;

        self.SSUtilService = SSUtilService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;
    }

}

SuperUnitTypesIndexController.$inject = ['SSUtilService', 'SSUserService'];
app.controller('SuperUnitTypesIndexController', SuperUnitTypesIndexController);

